<template>
  <div class="risk-exposure-header">
    <div class="risk-exposure-header__left">
      <div class="risk-exposure-header__text">
        {{ header }}
      </div>
      <VueSkeletonLoader
        v-if="loading"
        animation="wave"
        :color="'#bec3d8'"
        :height="16"
        :radius="'2'"
        type="rect"
      />
      <div
        v-else
        class="risk-exposure-header__amount-wrapper"
      >
        <GlGlobalSlotSwitcher class="risk-exposure-header__value-switcher">
          <template #item-0>
            {{ amount || formatByPrice(price) }}
          </template>
          <template
            v-if="amount && formatByPrice(price)"
            #item-1
          >
            {{ formatByPrice(price) || amount }}
          </template>
        </GlGlobalSlotSwitcher>
        <GlSkeletonAmount type="amount" />
      </div>
    </div>
    <div class="risk-exposure-header__right">
      <div
        v-if="loading || transactions"
        class="risk-exposure-header__text"
      >
        Evaluated Transactions
      </div>

      <div class="risk-exposure-header__amount flex-end">
        <VueSkeletonLoader
          v-if="loading"
          animation="wave"
          :color="'#bec3d8'"
          :height="16"
          :radius="'2'"
          type="rect"
        />
        <div v-else-if="transactions">
          {{ transactions }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//Component
import VueSkeletonLoader from 'skeleton-loader-vue'
import GlGlobalSlotSwitcher from '@/components/switchers/gl-global-slot-switcher'
import GlSkeletonAmount from '@//components/skeleton/gl-skeleton-amount'
// Utils
import { formatByPrice } from '@/utils/format-by-price'

export default {
  components: {
    VueSkeletonLoader,
    GlGlobalSlotSwitcher,
    GlSkeletonAmount,
  },
  props: {
    header: {
      type: String,
      default: '',
    },
    price: {
      type: [String, Number],
      default: '',
    },
    amount: {
      type: [String, Number],
      default: '',
    },
    transactions: {
      type: Number,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    essential: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatByPrice,
  },
}
</script>

<style>
.risk-exposure-header {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  min-height: 56px;
}
.risk-exposure-header__left,
.risk-exposure-header__right {
  flex: 0 0 calc(50% - 8px);
}
.risk-exposure-header__right {
  text-align: right;
}
.risk-exposure-header__text {
  margin-bottom: 4px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: var(--Accent-Dark-Grey);
}

.risk-exposure-header__amount {
  display: flex;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: var(--Accent-Space-Cadet);
}

.risk-exposure-header__value-switcher {
  display: flex;
  flex-shrink: 0;
  text-align: right;
  color: var(--Basic-900, #091540);
  font-size: var(--Size-L, 16px);
  font-weight: 600;
  line-height: var(--Line-Height-XL, 24px);
  letter-spacing: var(--Letter-Spacing-XS, -0.5px);
}

.risk-exposure-header .gl-skeleton-amount__amount {
  font-weight: 600;
}

@media (max-width: 767px) {
  .risk-exposure-header {
    flex-direction: column;
  }
  .risk-exposure-header__right {
    text-align: left;
  }
  .risk-exposure-header__amount {
    display: flex;
    justify-content: flex-start;
  }
}
</style>
